import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'bootstrap/dist/css/bootstrap.css';
import firebase from 'firebase';
// import 'bootstrap/dist/css/bootstrap-grid.css';
// import "./css/bootstrap.min.css"
// import "./css/bootstrap-theme.min.css"
// import registerServiceWorker from './registerServiceWorker';
// let C = require('sdusd-osps4-constants')

// if (C.SYSTEM.DEBUG) {
//   console.log('***** DEBUG IS TURNED ON! *****')
// }

const firebaseConfig = {
  apiKey: "AIzaSyBb0onTGVQ0hjWdJpI2uBIKLCh1dQg_Rz8",
  authDomain: "lop-phhs.firebaseapp.com",
  databaseURL: "https://lop-phhs.firebaseio.com",
  projectId: "lop-phhs",
  storageBucket: "lop-phhs.appspot.com",
  messagingSenderId: "1008770977658",
  appId: "1:1008770977658:web:a8a19af8f6af4967"
};

firebase.initializeApp(firebaseConfig);
let db = firebase.database();

ReactDOM.render(
  <App firebase={firebase} db={db}/>,
  document.getElementById('root')
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js